module.exports = __webpack_public_path__ + "media/build/add-icon-9cc06187.svg";